import gql from 'graphql-tag';

export const queryExamQuestions = gql`
  query ExamKey($mockExamId: ID!, $examCardId: ID!) {
    mockExamQuestions(mockExamId: $mockExamId) {
      id
      sections {
        id
        title
        meta {
          totalRealQuestions
          totalQuestions
        }
        questions {
          id
          type
          displayTopic
          title
          itemNumber
          referenceId
          fullScore
          examKeyCode
          answer {
            ... on MockExamAnswerSingle {
              singleValue: value
            }
            ... on MockExamAnswerMultiple {
              arrayValue: value
            }
          }
          subQuestions {
            id
            type
            displayTopic
            title
            itemNumber
            referenceId
            fullScore
            examKeyCode
            answer {
              ... on MockExamAnswerSingle {
                singleValue: value
              }
              ... on MockExamAnswerMultiple {
                arrayValue: value
              }
            }
          }
        }
      }
    }
    myMockExamAnswers(examCardId: $examCardId) {
      id
      answers {
        id
        referenceId
        isCorrect
        score
        answer {
          ... on MockExamAnswerSingle {
            singleValue: value
          }
          ... on MockExamAnswerMultiple {
            arrayValue: value
          }
        }
        answerAttributes {
          value
        }
      }
    }
  }
`;

export const getMockExamQuestionAssets = gql`
  query mockExamQuestionAsset(
    $mockExamId: ID!
    $questionType: MOCK_EXAM_QUESTION_TYPE!
    $keyCode: String!
    $itemNumber: Int!
  ) {
    mockExamQuestionAsset(
      mockExamId: $mockExamId
      questionType: $questionType
      keyCode: $keyCode
      itemNumber: $itemNumber
    ) {
      id
      solutionImages {
        title
        url
        itemNumber
        itemOrder
      }
      solutionVideo {
        title
        url
        providerCode
      }
    }
  }
`;
